import { Link } from "react-router-dom";
import {
  T, FONT_DISPLAY, FONT_MONO, PageShell, TopNav, Footer,
  container, eyebrow, italicAccent,
} from "@/lib/hybridTheme";

const EFFECTIVE_DATE = "November 15, 2025";

const SECTIONS = [
  { n: "I.",    h: "Acceptance of terms", body: (
    <p>By accessing or using Clients OnRamp (&ldquo;Service&rdquo;), you agree to be bound by these Terms &amp; Conditions. If you do not agree, do not use the Service.</p>
  )},
  { n: "II.",   h: "Description of service", body: (
    <p>Clients OnRamp is a consulting platform that (a) discovers local businesses that lack a website, (b) generates a free preview website for those businesses, and (c) offers an ongoing paid subscription for AI-powered lead-generation agents and automated outreach. All features are provided on an as-is basis.</p>
  )},
  { n: "III.",  h: "Communications and consent", body: (
    <p>When you contact Clients OnRamp — through our chat widget, booking form, phone, or email — you consent to receive replies via the same channel plus follow-ups from our team. You may opt out of SMS at any time by replying <strong>STOP</strong>; you may opt out of email marketing via the unsubscribe link. Standard carrier message and data rates may apply.</p>
  )},
  { n: "IV.",   h: "Free preview websites", body: (
    <p>Preview websites are provided as courtesy demonstrations for prospective clients whose businesses appear in public directories (Google Places, etc.) without an existing website. The preview is not a claim of authorized affiliation. Any business owner may request removal of a preview at any time by contacting us.</p>
  )},
  { n: "V.",    h: "Paid subscriptions", body: (
    <p>Monthly AI lead-generation subscriptions are billed via Stripe and renew automatically until cancelled. Cancel any time from your account portal — cancellation takes effect at the end of the current billing period. Refunds are provided at our sole discretion.</p>
  )},
  { n: "VI.",   h: "Acceptable use", body: (
    <p>You agree not to use the Service to send spam, unlawful, harassing, or fraudulent messages. Clients OnRamp may suspend or terminate accounts that violate this policy.</p>
  )},
  { n: "VII.",  h: "Limitation of liability", body: (
    <p>To the maximum extent permitted by law, Clients OnRamp is not liable for any indirect, incidental, consequential, or punitive damages arising out of use of the Service. Aggregate liability is limited to the fees paid to Clients OnRamp in the twelve months preceding the claim.</p>
  )},
  { n: "VIII.", h: "Changes", body: (
    <p>These Terms may be updated from time to time. Continued use of the Service after updates constitutes acceptance.</p>
  )},
  { n: "IX.",   h: "Contact", body: (
    <p>Questions about these Terms can be sent to <span style={{ fontFamily: FONT_MONO, color: T.coral }}>legal@clientsonramp.local</span> (replace with your business email once verified).</p>
  )},
];

export default function Terms() {
  return (
    <PageShell testId="terms-page">
      <TopNav />

      <section style={{ padding: "96px 0 40px" }}>
        <div style={container()}>
          <div style={{ maxWidth: 780 }}>
            <div style={eyebrow()}>Legal</div>
            <h1 style={{ fontFamily: FONT_DISPLAY, fontSize: "clamp(48px, 6vw, 80px)", lineHeight: 1.02, letterSpacing: "-0.03em", fontWeight: 400, margin: "16px 0 12px", color: T.ink }}>
              Terms &amp; <em style={italicAccent(T.coral)}>Conditions</em>
            </h1>
            <div style={{ fontFamily: FONT_MONO, fontSize: 12, color: T.inkMuted, letterSpacing: "0.08em", textTransform: "uppercase" }}>
              Effective {EFFECTIVE_DATE}
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: "40px 0 96px" }}>
        <div style={container()}>
          <div style={{ maxWidth: 780, background: T.panel, border: `1px solid ${T.line}`, padding: "48px 56px" }}>
            {SECTIONS.map((s) => (
              <section key={s.n} style={{ marginBottom: 40 }}>
                <div style={{ display: "flex", alignItems: "baseline", gap: 16, marginBottom: 14 }}>
                  <span style={{ fontFamily: FONT_DISPLAY, fontSize: 34, fontStyle: "italic", color: T.coral, fontWeight: 400, lineHeight: 1 }}>{s.n}</span>
                  <h2 style={{ fontFamily: FONT_DISPLAY, fontSize: 26, fontWeight: 500, letterSpacing: "-0.01em", margin: 0, color: T.ink }}>{s.h}</h2>
                </div>
                <div style={{ fontSize: 15, lineHeight: 1.7, color: T.inkMuted }}>{s.body}</div>
              </section>
            ))}
            <div style={{ borderTop: `1px solid ${T.line}`, marginTop: 12, paddingTop: 24 }}>
              <Link to="/privacy" style={{ color: T.coral, fontWeight: 700, fontSize: 14, textDecoration: "none", borderBottom: `1px solid ${T.coral}` }}>
                Privacy Policy →
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </PageShell>
  );
}
